import { render, staticRenderFns } from "./ChipsWithMore.vue?vue&type=template&id=d9db8064"
import script from "./ChipsWithMore.vue?vue&type=script&lang=ts"
export * from "./ChipsWithMore.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d9db8064')) {
      api.createRecord('d9db8064', component.options)
    } else {
      api.reload('d9db8064', component.options)
    }
    module.hot.accept("./ChipsWithMore.vue?vue&type=template&id=d9db8064", function () {
      api.rerender('d9db8064', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/ChipsWithMore.vue"
export default component.exports